import {Outlet} from "react-router";

export const Sessions = () => (
  <>
    <Outlet /> {/* settings */}
    <div>Hello Sessions</div>
  </>
);
